// extracted by mini-css-extract-plugin
export default {"searchListContainer":"SearchCardTemplateSelectionList_searchListContainer__39yI-"};